import React from "react";
import { Outlet } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { StickyMobileBar } from "../Sticky";

/**
 * Site shell: nav + routed page + footer.
 *
 * No Event structured data here. The 30 August Delhi edition has happened, and
 * a concluded event emitted site-wide is how you end up serving expired rich
 * results on every route. The past MusicEvents live on /delhi/ alone.
 */
export default function Layout() {
  return (
    <div className="App relative min-h-screen flex flex-col bg-[#0F0A07]">
      <ScrollToTop />
      <Nav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
